import {
  LOAD_CLIENT_DATA,
  SET_LAST_NAME_FILTER,
  SET_EDIT_CLIENT_ID,
  SET_REPORT_CLIENT,
  SET_SORT,
} from '../actions/advisor';

// default clientData state
export const initAdvisorData = {
  'clients': [],
  'lastNameFilter': '',
  'editClientID': null,
  'reportClient': null,
  'sortColumn': 'clientName',
  'sortDirection': 'ASC',
};

// advisorData reducer
const advisorData = (state, action) => {
  if(state === undefined) {
    return {};
  }
  switch (action.type) {
    case LOAD_CLIENT_DATA:
      return Object.assign({}, state, {
        clients: action.payload,
      });
    case SET_LAST_NAME_FILTER:
      return Object.assign({}, state, {
        lastNameFilter: action.payload,
      });
    case SET_EDIT_CLIENT_ID:
      return Object.assign({}, state, {
        editClientID: action.payload,
      });
    case SET_REPORT_CLIENT:
      return Object.assign({}, state, {
        reportClient: action.payload,
      });
    case SET_SORT:
      const column = action.column;
      let direction = 'ASC';
      if (column === state.sortColumn) {
        direction = state.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction,
      });
    default:
      return state;
  }
};

export default advisorData;



// WEBPACK FOOTER //
// ./src/reducers/advisor.js